import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Params } from '@angular/router';
import { InvitationApiObject } from '@qaroni-app/invitations/types/invitation-response';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';
import { CreateEmployeeDTO, UpdateEmployeeDTO } from '../types/employee';
import { EmployeeAddress } from '../types/employee-address';
import { EmployeeApiObject } from '../types/employee-response';
import { EmployeeNamesApiObject } from '../types/employee-names-response';
import { EmployeeReportApiObject } from '../types/employee-report-response';

@Injectable({
  providedIn: 'root',
})
export class EmployeeHttpService {
  private http = inject(HttpClient);

  public getEmployees$(companyID: number, params?: Params) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees`;

    return this.http.get<EmployeeApiObject>(url, {
      observe: 'response',
      params,
    });
  }

  public registerEmployee$(
    companyID: number,
    createEmployeeDTO: CreateEmployeeDTO
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees`;

    return this.http.post<EmployeeApiObject>(url, createEmployeeDTO, {
      observe: 'response',
    });
  }

  public getEmployee$(companyID: number, employeeID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/${employeeID}`;

    return this.http.get<EmployeeApiObject>(url, { observe: 'response' });
  }

  public updateEmployee$(
    companyID: number,
    employeeID: number,
    updateEmployeeDTO: UpdateEmployeeDTO
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/${employeeID}`;

    return this.http.patch<EmployeeApiObject>(url, updateEmployeeDTO, {
      observe: 'response',
    });
  }

  public updateEmployeeAddress$(
    companyID: number,
    employeeID: number,
    address: EmployeeAddress
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/${employeeID}/addresses`;

    return this.http.patch<EmployeeApiObject>(url, address, {
      observe: 'response',
    });
  }

  public removeEmployee$(companyID: number, employeeID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/${employeeID}`;

    return this.http.delete<EmployeeApiObject>(url, { observe: 'response' });
  }

  public sendInvitation$(companyID: number, invitationID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/invitations/${invitationID}`;

    return this.http.get<InvitationApiObject>(url, { observe: 'response' });
  }

  public resendInvitation$(companyID: number, invitationID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/invitations/${invitationID}/resends`;

    return this.http.post<InvitationApiObject>(url, null, {
      observe: 'response',
    });
  }

  public getNames$(companyID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/names`;

    return this.http.get<EmployeeNamesApiObject>(url, {
      observe: 'response',
    });
  }

  public exports$(companyID: number, params?: Params) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/exports`;

    return this.http.get<EmployeeReportApiObject>(url, {
      observe: 'response',
      params,
    });
  }
}
